$(function () {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/dist/js/sw.js')
            .then((serviceWorker) => {
                console.log('service worker registration successful')
            })
            .catch(() => {
                console.error('service worker registration failed')
            })
    } else {
        console.log('service worker unavailable');
    }
});